<div class="main medication-list global-table-wrapper">
    <div class="title-btn">
        <div class="main-title">
            <h1>Disinfection</h1>
            <p>list of disinfection</p>
        </div>
        <div class="new-placement" *appHasRole="['Admin', 'Farm manager']">
            <a routerLink="/add-disinfection" class="btn-action-primary"
                ><i class="fas fa-plus"></i> New Program</a
            >
        </div>
    </div>
    <app-search-filter
        [config]="filterConfig"
        [placeholder]="'Filter by Program Name or Disinfection Type'"
        (filter)="onFilterChange($event)"
        (clear)="onFilterClear()"
    ></app-search-filter>

    <p-table
        [value]="disinfections"
        [paginator]="true"
        [rows]="10"
        [totalRecords]="totalRecords"
        [lazy]="true"
        (onLazyLoad)="loadDisinfectionList($event)"
        [loading]="loading"
    >
        <ng-template pTemplate="header">
            <tr>
                <th style="width: 20%">Program Name</th>
                <th style="width: 15%">Disinfection Type</th>
                <th style="width: 50%">Instructions</th>
                <th style="width: 15%" *appHasRole="['Admin', 'Farm manager']">
                    Actions
                </th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-disinfection>
            <tr>
                <td>
                    <span class="program-name">{{
                        disinfection.disinfectionProgramName || 'N/A'
                    }}</span>
                </td>
                <td>
                    <span class="badge">{{
                        disinfection.disinfectionTypeName
                    }}</span>
                </td>
                <td>
                    <span
                        *ngFor="
                            let instruction of disinfection.instructionsName.split(
                                ','
                            )
                        "
                    >
                        <span class="badge">{{ instruction }}</span>
                    </span>
                </td>
                <td>
                    <div
                        class="action-icons"
                        *appHasRole="['Admin', 'Farm manager']"
                    >
                        <a
                            [routerLink]="[
                                '/disinfection-detail',
                                disinfection.id
                            ]"
                            pTooltip="View"
                            tooltipPosition="top"
                            class="table-action-icon"
                            ><i class="far fa-eye"></i
                        ></a>
                        <a
                            [routerLink]="[
                                '/edit-disinfection',
                                disinfection.id
                            ]"
                            pTooltip="Edit"
                            tooltipPosition="top"
                            class="table-action-icon"
                            ><i class="far fa-edit"></i
                        ></a>
                        <a
                            (click)="deleteDisinfection(disinfection.id)"
                            pTooltip="Delete"
                            tooltipPosition="top"
                            class="table-action-icon"
                            style="cursor: pointer"
                            ><i class="far fa-trash-alt"></i
                        ></a>
                    </div>
                </td>
                <!-- <td>
        <button pButton type="button" icon="pi pi-pencil" (click)="editDisinfection(disinfection.id)" class="p-button-text"></button>
        <button pButton type="button" icon="pi pi-trash" (click)="deleteDisinfection(disinfection.id)" class="p-button-text"></button>
      </td> -->
            </tr>
        </ng-template>
    </p-table>
</div>

<p-dialog
    [(visible)]="displayDeleteDialog"
    modal="true"
    [closable]="true"
    [style]="{width: '400px'}"
    [responsive]="true"
>
    <p class="text-center">
        Are you sure you want to delete this disinfection program?
    </p>
    <div class="text-center">
        <button (click)="deleteItem()" class="btn btn-danger mr-1">
            Delete
        </button>
        <button (click)="displayDeleteDialog = false" class="btn btn-secondary">
            Cancel
        </button>
    </div>
</p-dialog>
